exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required-bar-container[data-v-18b9f9ed]{background-color:#ff8a00;width:calc(100vw - 230px);color:#fff;padding:10px 12px;height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;z-index:10;position:fixed}.dummy[data-v-18b9f9ed]{width:100%;height:40px}.btn-close[data-v-18b9f9ed]{font-size:20px;padding:4px;cursor:pointer}", ""]);

// exports
